import { render, staticRenderFns } from "./ObjectProperties.vue?vue&type=template&id=bdb1970c&"
import script from "./ObjectProperties.vue?vue&type=script&lang=js&"
export * from "./ObjectProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports